import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';

function Blog() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const post = state?.post;

  if (!post) {
    navigate('/blogs');
    return null;
  }

  return (
    <>
      <Header
        title={post.Title}
        description={post.MetaDescription}
        structuredData={post.StructuredData}
      />
      <HeroSection
        heading={post.Title}
        subheading={post.SubTitle}
        tagline={post.TagLine}
      />
      <section
        className="features"
        dangerouslySetInnerHTML={{ __html: post.ContentHtml }}
      />
      {post.VideoUrl && (
        <section className="video-highlight">
          <div className="video-container">
            <iframe
              width="100%"
              height="400"
              src={post.VideoUrl}
              title={post.Title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </section>
      )}
    </>
  );
}

export default Blog;
